import determineLanguage from "../utils/cookie-language-helper";
import fetchWrapper from "../utils/fetchWrapper";


export default class HelpContentsService {
  //TODO: this is likely going to be loaded from an api endpoint now
  async GetHelpArticle(name) {
    try {
      const lang = determineLanguage();
      const url = `api/help/${name}?language=${lang}`;
      const data = await fetchWrapper({ url: url});
      return data;
    } catch (e) {
      console.log(`get help article: ${e}`);
      throw e;
    }
  }
  //TODO: sort out a solution for the storybook, wether it is by still using the api,
  //or keeping the old logic around where the javascript can build it from the files
  async LoadHelpCenter() {
    try {
      const lang = determineLanguage();
      const url = `api/help?language=${lang}`;
      const helpCenterData = await fetchWrapper({ url: url });
      return helpCenterData;
    } catch (e) {
      console.log(`load help center: ${e}`);
      throw e;
    }
  }

  /*keeping around in case I need it for reference when getting the storybook working again*/
  /*
  async LoadHelpCenter() {
    try {
      const url = `api/help`;
      //gets our help.json file which we use to build our help center json
      //help center json omits the page helpers.  Those are needed for the storybook
      //but not for the help center.
      const helpCenterData = await fetchWrapper({ url: url });
      const lang = determineLanguage();
      const baseUrl = `/help?lang=${lang}`;
      const returnData = {
        articlesOrder: helpCenterData.articles,
        articles: null,
        videosOrder: helpCenterData.videos,
        videos: null,
        //we load pages so they can be searched
        //pages: null
      };
      if (helpCenterData.articles && helpCenterData.articles.length > 0) {
        const articlesUrl = `${baseUrl}&files=${helpCenterData.articles.join(
          ","
        )}`;
        returnData.articles = await fetchWrapper({
          url: articlesUrl,
        });
      }
      if (helpCenterData.videos && helpCenterData.videos.length > 0) {
        const videosUrl = `${baseUrl}&files=${helpCenterData.videos.join(",")}`;
        returnData.videos = await fetchWrapper({
          url: videosUrl,
          req: this.req,
        });
      }
      return returnData;
    } catch (e) {
      console.log(`load help center: ${e}`);
      throw e;
    }
  }
   */
}
